import Joi from 'joi-browser';

export function getPreRegisterConfig() {
    return {
        scope: 'company',
        actionDelete: true,
        empty: {
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: ""
        },
        fieldTypes: {
            firstName: {
                fieldName: "First Name",
                required: true,
                type: 'text'
            },
            lastName: {
                fieldName: "Last Name",
                required: true,
                type: 'text'
            },
            email: {
                fieldName: "Email",
                required: true,
                type: 'email',
                noneditable: true
            },
            phoneNumber: {
                fieldName: "Phone",
                type: 'tel',
                required: true
            }
        },
        validationSchema: Joi.object().keys({
            firstName: Joi.string().required(),
            lastName: Joi.string().required(),
            email: Joi.string().required(),
            phoneNumber: Joi.string().required(),
            id: Joi.string(),
            companyId: Joi.string(),
            permission: Joi.number(),
            type: Joi.string()
        })
    }
}